import React from "react";
import {
  Content,
  ImageContainer,
  MainContainer,
  SelectItemImg,
} from "./styles";
import TopBar from "./components/TopBar";
import { Result } from "antd";
import SelectItem from "../../assets/svg/select.svg";
import useAdmin, { AdminProvider } from "./hooks/useAdmin";
import CRUDContent from "./components/CRUDContent";
import UserContent from "./components/UserContent";
import PostContent from "./components/PostContent";

const Admin: React.FC = (): JSX.Element => {
  const AdminContent = () => {
    const { adminState } = useAdmin();

    const switchScreens = () => {
      switch (adminState.selectedScreen) {
        case "CRUD":
          return (
            <Content>
              {adminState.selectedEnterprise ? (
                <CRUDContent />
              ) : (
                <ImageContainer>
                  <Result
                    icon={<SelectItemImg src={SelectItem} />}
                    title="Área Administrativa"
                    subTitle="Por favor, selecione um projeto para editar as informações."
                  />
                </ImageContainer>
              )}
            </Content>
          );
        case "USER":
          return (
            <Content>
              <UserContent />
            </Content>
          );
        case "POST":
          return (
            <Content>
              <PostContent />
            </Content>
          );
        default:
          return (
            <Content>
              <ImageContainer>
                <Result
                  icon={<SelectItemImg src={SelectItem} />}
                  title="Área Administrativa"
                  subTitle="Por favor, selecione um projeto para editar as informações."
                />
              </ImageContainer>
            </Content>
          );
      }
    };

    return (
      <MainContainer>
        <TopBar />
        {switchScreens()}
      </MainContainer>
    );
  };

  return (
    <AdminProvider>
      <AdminContent />
    </AdminProvider>
  );
};

export default Admin;
